import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteCarrierFailed, deleteCarrierSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteCarrier(action) {
  try {
    const url = `${BACKEND_URL}/registries/carriers/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteCarrierSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteCarrierFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteCarrierFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
